import { call, put, takeEvery } from "redux-saga/effects"

import { 
  GET_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS 
} from "./actionTypes"

import { 
  getClicksDashboardStickyColumnsError, 
  getClicksDashboardStickyColumnsSuccess, 
  updateClicksDashboardStickyColumnsError, 
  updateClicksDashboardStickyColumnsSuccess 
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* onGetClicksDashboardStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_clicks_dashboards`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getClicksDashboardStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getClicksDashboardStickyColumnsError(error))
  }
}

function* onUpdateClicksDashboardStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_clicks_dashboards/${action?.payload?.user_col_pref_clicks_dashboard?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateClicksDashboardStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateClicksDashboardStickyColumnsError(error))
  }
}

function* userClicksDashboardColumnPreferenceSaga() {
  yield takeEvery(GET_CLICKS_DASHBOARD_STICKY_COLUMNS, onGetClicksDashboardStickyColumns)
  yield takeEvery(UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS, onUpdateClicksDashboardStickyColumns)
}

export default userClicksDashboardColumnPreferenceSaga;
